import { render, staticRenderFns } from "./InviteUserPopupStep1.vue?vue&type=template&id=2c50bff4&scoped=true"
import script from "./InviteUserPopupStep1.vue?vue&type=script&lang=js"
export * from "./InviteUserPopupStep1.vue?vue&type=script&lang=js"
import style0 from "./InviteUserPopupStep1.vue?vue&type=style&index=0&id=2c50bff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50bff4",
  null
  
)

export default component.exports